const serviceTypeModel = {
    id: "serviceType",
    fields: {
        serviceType: "serviceType"
    }
};

export { serviceTypeModel };
//# sourceMappingURL=serviceTypeModel.js.map
